import { defineSagaForService } from '@repo/core'
import { getDevices } from '@repo/user-services'
import { devicesDataActions } from '../../slices'

export const devicesServiceConfig = defineSagaForService({
  [devicesDataActions.getRequest.type]: {
    apiClientDomain: 'user',
    service: getDevices,
    actionTypeResponse: devicesDataActions.getResponse.type,
    actionTypeRequest: devicesDataActions.getRequest.type,
  },
  [devicesDataActions.refreshRequest.type]: {
    apiClientDomain: 'user',
    service: getDevices,
    actionTypeResponse: devicesDataActions.refreshResponse.type,
    actionTypeRequest: devicesDataActions.refreshRequest.type,
  },
})
